import React                          from 'react';
import { observer }                   from 'mobx-react';
import { PlusOutlined }               from '@ant-design/icons';
import { Button }                     from 'antd';
import ProviderModel                  from 'models/ProviderModel';
import ProviderShowCategoryModel      from 'models/ProviderShowCategoryModel';
import { privateLayoutStore }         from 'stores/index';
import ProviderShowComponent          from './ProviderShowComponent';
import { ApiCollection }              from 'collections/ApiCollection';
import FormattedMessageWrapper        from 'components/App/FormattedMessageWrapper';
import CardBox                        from 'components/App/CardBox';
import { showDashboardStore }         from 'stores/index';
import rights                         from 'utils/rights';
import ProviderShowModel              from 'models/ProviderShowModel';
import { AppForm }                    from 'components/App/AppForm';
import ShowDashboardProviderShowModal from 'containers/Show/modals/ShowDashboardProviderShowModal';

@observer
class ShowDashboardProviderShowsBox extends React.Component {
  public providerCollection: ApiCollection<ProviderModel>;
  public providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;

  constructor(props: any) {
    super(props);

    this.providerCollection = new ApiCollection(ProviderModel);
    this.providerCollection.setFilters({
      itemsPerPage: 1000,
      'order[name]': 'asc',
    });
    this.providerShowCategoryCollection = new ApiCollection(ProviderShowCategoryModel);
    this.providerShowCategoryCollection.setFilter('pagination', false);
  }

  public componentDidMount() {
    this.providerCollection.list();
    this.providerShowCategoryCollection.list();
  }

  public render() {
    const { providerShowCollection } = showDashboardStore;

    return (
      <CardBox
        content={this.renderContent()}
        extra={this.renderExtra()}
        loading={!providerShowCollection.isLoaded || providerShowCollection.isLoading}
        title={<FormattedMessageWrapper id="Prestataires" />}
      />
    );
  }

  public renderContent = () => {
    const { providerShowCollection } = showDashboardStore;

    return (
      <div className="ShowDashboardProvidersBox__providers">
        {this.providerShowCategoryCollection.map((providerShowCategory: ProviderShowCategoryModel) => {
          const providerShows = providerShowCollection.models
            .slice()
            .filter(
              providerShow =>
                providerShow.get('providerShowCategory') === providerShowCategory.get('@id'),
            );

          if (providerShows.length < 1) {
            return null;
          }

          return (
            <React.Fragment key={providerShowCategory.get('@id')}>
              <div
                className="ShowDashboardProviderShowsBox__category"
                key={providerShowCategory.get('@id')}
              >
                <strong>{providerShowCategory.get('name')}</strong>
              </div>
              {providerShows.map((providerShow: ProviderShowModel) => (
                <ProviderShowComponent
                  displayRightComponent
                  key={providerShow.id}
                  onDeleteProviderShow={this.onDeleteProviderShow}
                  providerCollection={this.providerCollection}
                  providerShow={providerShow}
                  providerShowCategory={providerShowCategory}
                  providerShowCategoryCollection={this.providerShowCategoryCollection}
                />
              ))}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  public renderExtra = () => {
    if (!rights.for.provider.add) {
      return null;
    }

    const { providerShowCollection, showModel } = showDashboardStore;

    return (
      <div className="ShowDashboardProviderShowsBox__addAction">
        <Button
          icon={<PlusOutlined />}
          onClick={() =>
            AppForm.open(
              ShowDashboardProviderShowModal,
              {
                onDeleteProviderShow: this.onDeleteProviderShow,
                providerCollection: this.providerCollection,
                providerShowCategoryCollection: this.providerShowCategoryCollection,
                providerShowCollection,
                show: showModel,
              },
              {
                title: <FormattedMessageWrapper id="Paramétrage des prestataires du salon" />,
              },
            )
          }
        />
      </div>
    );
  };

  private onDeleteProviderShow = () => {
    const { providerShowCollection } = showDashboardStore;

    providerShowCollection.list();
    privateLayoutStore.fetchProvidingData();
  };
}

export default ShowDashboardProviderShowsBox;
